import { year } from '@jbc-year-end-adj/2024/consts';
import { ReportName } from './types';

export const REPORTS = [
  'withholdingSlip',
  'insuranceDeduction',
  'bsiDeduction',
  'dependentDeductionThisYear',
  'dependentDeductionNextYear',
  'fileMount'
] as const;

const ERA_NAME = '令和';
const ERA_NUMBER = year - 2018;

export const REPORT_MAP: { [key in ReportName]: string } = {
  withholdingSlip: '源泉徴収票',
  insuranceDeduction: `${ERA_NAME}${ERA_NUMBER}年分 給与所得者の保険料控除申告書`,
  bsiDeduction: `${ERA_NAME}${ERA_NUMBER}年分 給与所得者の基礎控除申告書 兼 給与所得者の配偶者控除等申告書 兼 年末調整に係る定額減税のための申告書 兼 所得金額調整控除申告書`,
  dependentDeductionThisYear: `${ERA_NAME}${ERA_NUMBER}年分 給与所得者の扶養控除等（異動）申告書`,
  dependentDeductionNextYear: `${ERA_NAME}${ERA_NUMBER + 1}年分 給与所得者の扶養控除等（異動）申告書`,
  fileMount: '添付書類台紙'
};
